<template>
  <div class="customers">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">
        {{ util.language('客户', 'Customers') }}
      </el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('编码', 'Code')">
        <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="searchParam.codeLike" clearable />
      </el-form-item>
      <el-form-item :label="util.language('电话号', 'Phone')">
        <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="searchParam.phoneLike" clearable />
      </el-form-item>
      <el-form-item :label="util.language('名称', 'Name')">
        <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="searchParam.nameLike" clearable />
      </el-form-item>
      <el-form-item :label="util.language('状态', 'State')">
        <el-select clearable v-model="searchParam.enable" style="width: 120px;">
          <el-option :key="true" :label="util.language('启用', 'Enable')" :value="true" />
          <el-option :key="false" :label="util.language('停用', 'Disable')" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('搜索', 'Search') }}</el-button>
          <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">{{ util.language('新增', 'New') }}</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">{{ util.language('详情', 'Detail') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.customerList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="70" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="enable" :label="util.language('状态', 'State')" align="center" width="90">
        <template #default="scope">
          <el-tag v-if="scope.row.enable" type="success">{{ util.language('启用', 'Enable') }}</el-tag>
          <el-tag v-else type="danger">{{ util.language('停用', 'Disable') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="code" :label="util.language('编码', 'Code')" width="120" show-overflow-tooltip />
      <el-table-column prop="phone" :label="util.language('电话号', 'Phone')" width="150" show-overflow-tooltip />
      <el-table-column prop="name" :label="util.language('名称', 'Name')" min-width="100" show-overflow-tooltip />
      <el-table-column prop="finishOrderCount" :label="util.language('完成订单数', 'Finished')" align="right" width="100" show-overflow-tooltip />
      <el-table-column prop="customerNote" :label="util.language('客户备注', 'Customer note')" width="130" show-overflow-tooltip />
      <el-table-column prop="insiderNote" :label="util.language('内部备注', 'Insider note')" min-width="100" show-overflow-tooltip />
      <el-table-column :label="util.language('创建时间', 'Create time')" width="160" show-overflow-tooltip>
        <template #default="scope">
          <el-text>{{ util.parseTime(scope.row.createDatetime) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column :label="util.language('操作', 'Operations')" width="110" show-overflow-tooltip>
        <template #default="scope">
          <el-link type="primary" @click="toAddresses(scope.row)">{{ util.language('编辑地址', 'Edit address') }}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.customerTotal" @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const shopId = cache.getString(cache.keys.shopId) * 1
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const router = useRouter()
const tabRef = ref()

const data = reactive({
  customerList: [],
  customerTotal: 0,
})
const loading = reactive({
  find: false,
})
const show = reactive({
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 50
  searchParam.shopId = shopId
  searchParam.codeLike = ''
  searchParam.phoneLike = ''
  searchParam.nameLike = ''
  searchParam.enbale = null
}
resetSearchParam()

const commitFindList = () => {
  loading.find = true
  api.get('/backend/customer/getCustomerPage', { params: searchParam }).then(res => {
    data.customerList = res.list
    data.customerTotal = res.total
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'customer', null)
  router.push('/customer')
}

const update = (row) => {
  const customer = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'customer', customer)
  router.push('/customer')
}

const toAddresses = (row) => {
  const customer = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'customerAddresses', customer)
  router.push('/customerAddresses')
}

</script>

<style lang="less"></style>